import { useSuspenseQuery } from '@tanstack/react-query';

import type { SavedQuery } from '@/entities/query';
import { socialApiClient } from '../api-client/social-api-client';

export async function fetchSavedQueries({
  workspaceId,
}: {
  workspaceId: string;
}): Promise<SavedQuery[]> {
  const response = await socialApiClient.get<{
    queries: Array<SavedQuery>;
  }>(`workspaces/${workspaceId}/queries`);

  const data = await response.json();

  // Map to SavedQuery type
  return data.queries;
}

export function useSavedQueries({ workspaceId }: { workspaceId: string }) {
  const response = useSuspenseQuery({
    queryKey: ['saved-queries', workspaceId],
    queryFn: () => fetchSavedQueries({ workspaceId }),
    staleTime: 1000 * 60 * 5,
  });
  const publicQueries = response.data.filter((query) => query.type === 'public') ?? [];
  const privateQueries = response.data.filter((query) => query.type === 'private') ?? [];
  return {
    ...response,
    data: [...privateQueries, ...publicQueries],
  };
}
